export enum NpsTestIds {
  CONTAINER = 'nps-container',
  BUTTON_ANSWER_LATER = 'nps-button-answer-later',
  BUTTON_SUBMIT_SCORE = 'nps-button-submit-score',
  SLIDER = 'nps-slider',
  SEND_LATER_BUTTON = 'nps-send-later-button',
}
